import { View } from '@react-pdf/renderer';
import React from 'react';
import type { Collection, MyListPageItem } from './MyList';
import Header from './MyList.Header';
import ProductList from './MyList.ProductList';
import Sidebar from './MyList.Sidebar';

export default function Halfpage({
  item: exhibitor,
  collection,
}: {
  item: MyListPageItem;
  collection: Collection;
}) {
  return (
    <View
      style={{
        paddingHorizontal: '10mm',
        paddingVertical: '10mm',
        height: '148mm',
      }}
    >
      <Header exhibitor={exhibitor} />
      <View
        style={{
          flexDirection: 'row',
          flexGrow: 1,
        }}
      >
        <Sidebar exhibitor={exhibitor} collection={collection} />
        <ProductList exhibitor={exhibitor} />
      </View>
    </View>
  );
}
